import { createClient } from '@supabase/supabase-js'

export const supabase = createClient(
  'https://zkvxnsyktfwvphnzvtvo.supabase.co',
  'sb_publishable_G2Ms6QbytngqIWVkG6wyiA_DANvxvUa'
)
